export default "__VITE_ASSET__CIRwkzlV__"